export const USER_ONBOARDING = 'USER_ONBOARDING';
export const WIZARD_ONBOARDING = 'WIZARD_ONBOARDING';
export const USER_ONBOARDING_DISMISSED_KEY = 'ZRM_hasDismissedUserOnboarding';
